module.exports = __webpack_public_path__ + "static/img/vision_values_pt.32799a56.png";